import { IEmail } from "@/types/common";
import BaseTable, {
  BaseTableColumn,
  FieldData,
  TABLE_COLUMNS,
} from "../../components/tables/BaseTable";
import MoveToManualReviewButton from "@/components/tables/components/MoveToManualReviewButton";
import React, { useMemo } from "react";

const FailedEmailsTable = ({
  failedEmails,
  pagination,
  setPagination,
  totalCount,
  loading,
}: {
  failedEmails: IEmail[];
  pagination: { page: number; limit: number; };
  setPagination: (pagination: { page: number; limit: number ;}) => void;
  totalCount: number;
  loading: boolean;
}) => {
  const COLUMNS_TO_RENDER: BaseTableColumn[] = [
    "dateTime",
    "mailbox",
    "subject",
    "sender",
    "error",
    "moveToManualReview",
  ];

  const tableColumns = useMemo(
    () => ({
      ...TABLE_COLUMNS,
      moveToManualReview: {
        ...TABLE_COLUMNS.moveToManualReview,
        renderCell: (field: FieldData) =>
          field?.id != null ? (
            <MoveToManualReviewButton
              emailId={field.id}
              listPagination={pagination}
            />
          ) : null,
      },
    }),
    [pagination],
  );

  return (
    <BaseTable
      columns={COLUMNS_TO_RENDER}
      data={failedEmails}
      tableColumns={tableColumns}
      pagination={pagination}
      setPagination={setPagination}
      totalCount={totalCount}
      loading={loading}
    />
  );
};
export default FailedEmailsTable;
